import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=6b763141&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Task.vue?vue&type=style&index=1&id=6b763141&prod&scoped=true&lang=css"
import style2 from "./Task.vue?vue&type=style&index=2&id=6b763141&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b763141",
  null
  
)

export default component.exports